<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-shadow"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">{{ type === 'product' ? "Let's Talk" : '댓글' }}</h3>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-flex xs12 style="padding-bottom: 74px;">
        <v-card tile flat class="card-shadow pa-0 pt-2 ma-0">
          <v-list class="pa-0 px-3">
            <CommentListTile v-for="(comment, index) of comments" :key="index"
                             :idx="comment.idx"
                             :postIdx="parseInt(idx)"
                             :createdAt="comment.created_at"
                             :updatedAt="comment.updated_at"
                             :contents="comment.contents"
                             :likeCnt="comment.like_cnt"
                             :likes="comment.likes"
                             :user="comment.user"
                             :recommentCnt="type === 'product' ? comment.comment_cnt : comment.recomment_cnt"
                             :recomments="type === 'product' ? comment.comments : comment.recomments"
                             @like="like"
                             @comment="recomment"
                             @report="report"
                             @remove="remove"
                             @moreRecomment="selectMore" />
          </v-list>
        </v-card>
      </v-flex>

      <v-footer height="74px"
                class="pa-3"
                fixed
                color="#f8f8f8"
                style="width: 100%;">
        <v-text-field class="border-radius-custom"
                      solo flat hide-details
                      append-icon="게시"
                      placeholder="댓글"
                      v-model="comment"
                      ref="comment"
                      @click:append.stop="submitComment"
                      @keyup.enter="submitComment">
        </v-text-field>
      </v-footer>

      <!-- 임시 스낵바 -->
      <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
        {{ snackbarMessage }}
        <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
      </v-snackbar>

    </v-layout>
  </v-container>
</template>

<script>
  import CommentListTile from '@/components/CommentListTile';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'Comments',
    props: [ 'idx', 'type' ],
    components: { CommentListTile },
    computed: {
      ...mapGetters('post', { postComments: 'comments' }),
      ...mapGetters('product', { productTalks: 'talks' }),
      comments () {
        return this.type === 'product' ? this.productTalks : this.postComments;
      }
    },
    data () {
      return {
        time: parseInt(new Date().getTime() / 1000),
        page: 1,
        bottom: true,
        comment: '',
        recommentTo: -1,
        snackbar: false,
        snackbarMessage: '',
      };
    },
    created () {
      this.select();
      window.addEventListener('scroll', this.bottomVisible);
    },
    destroyed () {
      window.removeEventListener('scroll', this.bottomVisible);
    },
    watch: {
      comment (text) {
        if (text === '') {
          this.recommentTo = -1;
        }
      },
      bottom (bottom, oldBottom) {
        if (bottom && !oldBottom) {
          this.select();
        }
      },
    },
    methods: {
      ...mapActions('post', {
        postSelectComments: 'selectComments', postSelectRecomments: 'selectRecomments',
        createComment: 'createComment', createRecomment: 'createRecomment',
        toggleLikeComment: 'toggleLikeComment', toggleLikeRecomment: 'toggleLikeRecomment',
        reportComment: 'reportComment', reportRecomment: 'reportRecomment',
        deleteComment: 'deleteComment', deleteRecomment: 'deleteRecomment',
      }),
      ...mapActions('product', {
        productSelectTalks: 'selectTalks', productSelectComments: 'selectComments',
        createTalk: 'createTalk', createTalkComment: 'createComment',
        toggleLikeTalk: 'toggleLikeTalk', toggleLikeTalkComment: 'toggleLikeComment',
        reportTalk: 'reportTalk', reportTalkComment: 'reportComment',
        deleteTalk: 'deleteTalk', deleteTalkComment: 'deleteComment',
      }),
      select () {
        if (this.type === 'product') { // select talks
          this.productSelectTalks({ second: this.time, idx: this.idx, page: this.page }).then(() => {
            this.page++;
          });
        } else {
          this.postSelectComments({ second: this.time, idx: this.idx, page: this.page }).then(() => {
            this.page++;
          });
        }
      },
      selectMore (payload) {
        if (payload.recommentOffset <= payload.recommentCnt) {
          if (this.type === 'product') { // select comments of a talk
            this.productSelectComments({ second: this.time, storeIdx: this.idx, talkIdx: payload.commentIdx, offset: payload.recommentOffset });
          } else {
            this.postSelectRecomments({ second: this.time, postIdx: this.idx, commentIdx: payload.commentIdx, offset: payload.recommentOffset });
          }
        }
      },
      submitComment () {
        if (this.comment === '') return false;
        if (this.type === 'product') {
          if (this.recommentTo > -1) {
            this.createTalkComment({ storeIdx: this.idx, talkIdx: this.recommentTo, content: this.comment }).then(() => {
              this.comment = '';
              // window.scrollTo(0, 0); // TODO: recomment 작성한 글위치로 스크롤
            });
          } else {
            this.createTalk({ idx: this.idx, content: this.comment }).then(() => {
              this.comment = '';
              window.scrollTo(0, 0);
            });
          }
        } else {
          if (this.recommentTo > -1) {
            this.createRecomment({ postIdx: this.idx, commentIdx: this.recommentTo, content: this.comment }).then(() => {
              this.comment = '';
              // window.scrollTo(0, 0); // TODO: recomment 작성한 글위치로 스크롤
            });
          } else {
            this.createComment({ idx: this.idx, content: this.comment }).then(() => {
              this.comment = '';
              window.scrollTo(0, 0);
            });
          }
        }
      },
      like (payload) {
        if (this.type === 'product') {
          if (typeof payload.commentIdx === 'undefined') {
            this.toggleLikeTalk({ storeIdx: payload.postIdx, talkIdx: payload.idx });
          } else {
            this.toggleLikeTalkComment({ storeIdx: payload.postIdx, talkIdx: payload.commentIdx, commentIdx: payload.idx });
          }
        } else {
          if (typeof payload.commentIdx === 'undefined') {
            this.toggleLikeComment({ postIdx: payload.postIdx, commentIdx: payload.idx });
          } else {
            this.toggleLikeRecomment({ postIdx: payload.postIdx, commentIdx: payload.commentIdx, recommentIdx: payload.idx });
          }
        }
      },
      remove (payload) {
        if (this.type === 'product') {
          if (typeof payload.commentIdx === 'undefined') {
            this.deleteTalk({ storeIdx: payload.postIdx, talkIdx: payload.idx });
          } else {
            this.deleteTalkComment({ storeIdx: payload.postIdx, talkIdx: payload.commentIdx, commentIdx: payload.idx });
          }
        } else {
          if (typeof payload.commentIdx === 'undefined') {
            this.deleteComment({ postIdx: payload.postIdx, commentIdx: payload.idx });
          } else {
            this.deleteRecomment({ postIdx: payload.postIdx, commentIdx: payload.commentIdx, recommentIdx: payload.idx });
          }
        }
      },
      recomment (payload) {
        console.log('recomment', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.comment = `@${payload.commentUserName} `;
          this.recommentTo = payload.idx;
        } else {
          this.comment = `@${payload.commentUserName} `;
          this.recommentTo = payload.commentIdx;
        }
        this.$refs.comment.focus();
      },
      report (payload) {
        if (this.type === 'product') {
          if (typeof payload.commentIdx === 'undefined') {
            this.reportTalk({ storeIdx: payload.postIdx, talkIdx: payload.idx }).then(response => {
              if (!response.data) this.showSnackbar('이미 신고한 글입니다.');
              else this.showSnackbar('글이 신고되었습니다.');
            }).catch(err => {
              console.error(err);
            });
          } else {
            this.reportTalkComment({ storeIdx: payload.postIdx, talkIdx: payload.commentIdx, commentIdx: payload.idx }).then(response => {
              if (!response.data) this.showSnackbar('이미 신고한 댓글입니다.');
              else this.showSnackbar('뎃글이 신고되었습니다.');
            }).catch(err => {
              console.error(err);
            });
          }
        } else {
          if (typeof payload.commentIdx === 'undefined') {
            this.reportComment({ postIdx: payload.postIdx, commentIdx: payload.idx }).then(response => {
              if (!response.data) this.showSnackbar('이미 신고한 댓글입니다.');
              else this.showSnackbar('댓글이 신고되었습니다.');
            }).catch(err => {
              console.error(err);
            });
          } else {
            this.reportRecomment({ postIdx: payload.postIdx, commentIdx: payload.commentIdx, recommentIdx: payload.idx }).then(response => {
              if (!response.data) this.showSnackbar('이미 신고한 댓글입니다.');
              else this.showSnackbar('댓글이 신고되었습니다.');
            }).catch(err => {
              console.error(err);
            });
          }
        }
      },
      showSnackbar (message) {
        this.snackbarMessage = message;
        this.snackbar = true;
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 200;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 4px 36px rgba(234, 234, 234, 50);
  }

  /deep/.border-radius-custom {
    overflow: hidden;
    border-radius: 21px !important;
    .v-input__slot {
      cursor: pointer !important;
      padding: 0 18px !important;
    }
    input {
      cursor: pointer !important;
    }
    .v-icon {
      color: map_get($colors, primary);
      font-size: 12px;
    }
  }

</style>
